var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseContent',[_c('BaseSection',{attrs:{"title":"History","padded":""}},[_c('p',{class:_vm.$style.timezoneNote},[_vm._v(" Showing times in "+_vm._s(_vm.clientTimezoneLabel)+" ")]),_c('ShowScheduleMixBlock',{attrs:{"resources":_vm.stationsPlaylist}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }